// Slide Custom Button JS
let slideBtnsRight = document.querySelectorAll('.slide-btn-right');
let starts = document.querySelector('.fa-solid');

slideBtnsRight.forEach(btn => {
  if(btn) {
    btn.addEventListener('click', function(el) {
    console.log("text1"+btn.classList.contains("right-first"));
      if(btn.classList.contains("right-first") && (document.querySelectorAll('[name="user_type"]')[0].checked || document.querySelectorAll('[name="user_type"]')[1].checked)){
        
      document.querySelector('.swiper-button-next').click();
      }
      if(starts.classList.contains('active')){
             
         document.querySelector('.swiper-button-next').click();
        
      }
if(document.getElementById("s2a-slide").value == "")
{
  
   document.querySelector('.swiper-button-next').addClass("system");
}
    });
   
};
});



let slideBtnsLeft = document.querySelectorAll('.slide-btn-left');
slideBtnsLeft.forEach(btn => {
  if(btn) {
    btn.addEventListener('click', function() {
      
      if(btn.classList.contains("18-btn-prev")){
        let currentSlide = swiper.activeIndex - 2;
        swiper.slideTo(currentSlide);
      } else {
        document.querySelector('.swiper-button-prev').click();
      }
    })
  }
})

//Shah arrows slides 
$('.radio-field21 input').click(function(){
  $(this).parents('.slide-main-mh').siblings('.pos-right').addClass('active-btn');
});
